import { getMonth, getYear, isEqual } from 'date-fns';
import { formatInTimeZone, utcToZonedTime } from 'date-fns-tz';
import { getLocale } from 'modules/i18n';
import { DateFormat } from './types';

const getTimeWithTimezone = (dateString: string, timezone: string): Date =>
  utcToZonedTime(new Date(dateString), timezone);

export const getHoursAndMinutesLabel = (timeInMinutes: number) => {
  if (timeInMinutes < 0) return '';

  const hours = Math.floor(timeInMinutes / 60);
  const minutes = timeInMinutes % 60;

  let timeLabel = '';
  if (hours) {
    timeLabel += `${hours}h`;
  }
  if (hours && minutes) {
    timeLabel += ' ';
  }
  if (minutes) {
    timeLabel += `${minutes}min`;
  }
  if (!hours && !minutes) {
    timeLabel = '0h';
  }
  return timeLabel;
};

export const formatDateWithTimezone = (
  dateString: string,
  dateFormat: DateFormat,
  timezone: string
) => {
  const locale = getLocale();
  const date = new Date(dateString);

  return formatInTimeZone(date, timezone, dateFormat, { locale });
};

export const isYearDifferentWithTimezone = (
  start: string,
  end: string,
  timezone: string
) => {
  const startTime: Date = getTimeWithTimezone(start, timezone);
  const endTime: Date = getTimeWithTimezone(end, timezone);

  return !isEqual(getYear(startTime), getYear(endTime));
};

export const isMonthDifferentWithTimezone = (
  start: string,
  end: string,
  timezone: string
) => {
  const startTime: Date = getTimeWithTimezone(start, timezone);
  const endTime: Date = getTimeWithTimezone(end, timezone);

  return !isEqual(getMonth(startTime), getMonth(endTime));
};

export const getShortDateLabelWithTimezone = (
  dateString: string,
  timezone: string
) => {
  const dayWithMonth = formatDateWithTimezone(
    dateString,
    DateFormat.DAY_WITH_SHORT_MONTH,
    timezone
  );
  const year = formatDateWithTimezone(
    dateString,
    DateFormat.SHORT_YEAR,
    timezone
  );

  return `${dayWithMonth}'${year}`;
};

export const isExceedingAllowedDuration = (
  start: Date | null,
  end: Date | null,
  allowedDuration: number
): boolean => {
  if (!start || !end) return false;

  const timeDifference = end.getTime() - start.getTime();

  return timeDifference > allowedDuration || timeDifference < 0;
};
